import { FC, memo, useCallback, useEffect, useState } from 'react'

import { useLocation } from '@tanstack/react-router'
import { useBankPortalContext } from 'bank-portal-context'
import { InnerMenu, MenuItem, Tooltip } from 'ui/components'

import { MainMenuProps } from './MainMenuProps'
import { Toggle } from './Toggle'

import { MainMenuBox, Title } from './styles'

export const MainMenu: FC<MainMenuProps> = memo((props) => {
  const { items, connectionsItems, minimized } = props
  const [isMainActive, setMainActive] = useState(true)
  const pathname = useLocation({ select: (s) => s.pathname })
  const onClickMain = useCallback(() => setMainActive(true), [setMainActive])
  const onClickPage = useCallback(() => setMainActive(false), [setMainActive])

  const { customSidebarItems } = useBankPortalContext()

  useEffect(() => {
    setMainActive(!customSidebarItems.length)
  }, [customSidebarItems, setMainActive])

  return (
    <>
      <Toggle
        isMainActive={isMainActive}
        isVisible={customSidebarItems.length !== 0}
        isMinimized={minimized}
        onClickMain={onClickMain}
        onClickPage={onClickPage}
      />
      {isMainActive ? (
        <>
          <MainMenuBox>
            {items.map((item, index) => (
              <Tooltip key={index} id={item.to} type="dark" place="right" isVisible={minimized} content={item.children}>
                <MenuItem
                  {...item}
                  iconName={item.icon}
                  isMinimized={minimized}
                  isActive={pathname.indexOf(item.to) === 0}
                >
                  {item.children}
                </MenuItem>
              </Tooltip>
            ))}
          </MainMenuBox>
          <>
            {connectionsItems && connectionsItems.length > 0 && (
              <MainMenuBox>
                <Title isMinimized={minimized}>Connections</Title>
                {connectionsItems.map((item, index) => (
                  <Tooltip
                    key={index}
                    id={item.to}
                    type="dark"
                    place="right"
                    isVisible={minimized}
                    content={item.children}
                  >
                    <MenuItem
                      {...item}
                      iconName={item.icon}
                      isMinimized={minimized}
                      isActive={pathname.indexOf(item.to) === 0}
                    >
                      {item.children}
                    </MenuItem>
                  </Tooltip>
                ))}
              </MainMenuBox>
            )}
          </>
        </>
      ) : (
        customSidebarItems.length > 0 && <InnerMenu items={customSidebarItems} />
      )}
    </>
  )
})
